import React from "react";

import FTNavMessage from "./NavMessage";

import "./Socket.css";

/**
 * NavIcon()
 * 	This is the Navigation Icon to put in the header
 * 	This component follows the paradigm of the rhombus-react App Header
 * 		If the application is using the rhombus-react App Header
 * 		Then this component can be dropped in as a new icon
 */

export default function NavIcon({  domNode, socketInstance, debug = false }){
	try {
		// Viewing the messages goes into it's own React Portal
		// If there is a domNode with the given ID already in the HTML, we will use that
		// If not, we will try and add a new div to the document
		// 	There's really no reason why that should ever fail, but just in case, it's all wrapped in try/catch
		let node = document.getElementById(domNode);
		if(!node){
			let div = document.createElement("div");
			div.setAttribute("id", domNode);
			document.body.append(div);
		}
	} catch (err){
		console.warn("Unable to find or make DOM Node for Message Portal");
		console.warn("Socket Messages might not work as expected!");
	}

	return {
		id:"messages",
		icon:"fas fa-bell",
		title:"Messages",
		className:"ft-messages",
		renderChild:(props, classes) => {
			return <FTNavMessage classes={classes} domNode={domNode} socketInstance={socketInstance} __debug={debug} />;
		},
	};
}
